export default __webpack_public_path__ + "static/media/img--park.2c8326b1.jpg";